import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { getAllRefData } from '@/data-provider/refDataProvider';

type Props = {
  resource: string;
  headers: string[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamoDataTable',
  props: {
    resource: null,
    headers: null
  },
  setup(__props: any) {

const props = __props as {
  resource: string;
  headers: string[];
}



const resources = ref([] as any[]);
const resourcesLoaded = ref(false);

const populateList = () => {
  getAllRefData(props.resource, { path: props.resource }).then((refData) => {
    resources.value = refData as any[];
    resourcesLoaded.value = true;
  });
};

populateList();

const pageData = {
  page: 1,
  perPage: 15,
  lastEvaluatedKey: [null],
};

return { __sfc: true,props, resources, resourcesLoaded, populateList, pageData }
}

})